import React from 'react';
import Link from 'next/link';

const COLLECTIONS = [
  {
    name: 'Basic',
    count: 198,
    path: '/basic-icons',
    image: '/images/collection_basic_cover.png',
  },
  {
    name: 'Outline',
    count: 6750,
    path: '/outline-icons',
    image: '/images/collection_outline_cover.png',
  },
  {
    name: 'Basic3D',
    count: 2860,
    path: '/basic3d',
    image: '/images/collection_basic3d_cover.png',
  },
  {
    name: 'Polish-Blue',
    count: 399,
    path: '/polish-blue-icons',
    image: '/images/collection_polish-blue_cover.png',
  },
];

const IconCollections = () => {
  return (
    <section className="w-full py-16">
      {/* Header using Tailwind classes */}
      <div className="grid grid-cols-8 justify-center items-center max-w-[1400px] w-[90%] mx-auto py-[15px] mb-16 mt-20">
        <h1 className="text-5xl leading-tight tracking-tight mb-2 col-span-8 text-center">Simple Beautiful Icons</h1>
        <p className="text-base text-black mt-2 col-span-8 text-center md:block hidden">For design, websites, applications, games<br />any business use.</p>
      </div>
      
      {/* Collections Grid */}
      <div className="max-w-7xl w-[90%] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {COLLECTIONS.map((collection) => (
            <CollectionCard 
              key={collection.name}
              collection={collection}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

// Collection card with original sizing
const CollectionCard = ({ collection }) => {
  return (
    <Link href={collection.path} className="block no-underline">
      <div className="border border-gray-300 rounded-lg bg-white h-full transition-transform duration-300 hover:-translate-y-2">
        <div className="py-18 px-12">
          {/* Image container with fixed aspect ratio */}
          <div className="mb-3 flex justify-center">
            <img
              src={collection.image}
              alt={`${collection.name} collection`}
              className="max-w-full h-auto"
            />
          </div>
          
          {/* Text content */}
          <div className="mt-8">
            <h2 className="text-lg font-medium text-gray-800">{collection.name}</h2>
            <p className="text-gray-600">{collection.count} icons</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default IconCollections;